import { xor } from 'lodash';

import { DigestApi } from '@api/briefings/model/digest-api';
import { BaseModel } from '@Common/Basic/models/base.model';


export class Digest extends BaseModel<Digest, DigestApi> {
    id: number;
    guid: string;

    accountId: number;
    briefingIds: number[];

    // readonly properties
    createdByUserId: number;
    createdDate: Date;

    lastModifiedByUserId: number;
    lastModifiedDate: Date;


    constructor(apiModel?:  DigestApi) {
        super();
        if (apiModel) {
            this.constructFromApiModel(apiModel);
        } else {
            this.constructDefault();
        }
    }

    constructFromApiModel(apiModel: DigestApi) {
        this.id = apiModel.id;
        this.name = apiModel.digestName;
        this.guid = apiModel.guid;
        this.accountId = apiModel.accountId;
        this.briefingIds = apiModel.briefingIds;
        this.createdByUserId = apiModel.createdByUserId;
        this.createdDate = apiModel.createdDate ? new Date(apiModel.createdDate) : null;
        this.lastModifiedByUserId = apiModel.lastModifiedByUserId;
        this.lastModifiedDate = apiModel.lastModifiedDate ? new Date(apiModel.lastModifiedDate) : null;
    }

    constructDefault() {
        this.id = null;
        this.name = null;
    }

    toApiModel(): DigestApi {
        return {
            id: this.id,
            digestName: this.name,
            guid: this.guid,
            accountId: this.accountId,
            briefingIds: this.briefingIds,
        };
    }

    clone(): Digest {
        return new Digest(this.toApiModel());
    }

    equals(other?: Digest): boolean {
        if (!other) {
            return false;
        }

        if (this.id !== other.id) {
            return false;
        }

        if (this.guid !== other.guid) {
            return false;
        }

        if (this.accountId !== other.accountId) {
            return false;
        }

        if (xor(this.briefingIds, other.briefingIds).length > 0) {
            return false;
        }

        return true;
    }
}
